import { PureComponent } from 'react';
import enviro from 'enviro';
import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import getEmbedCode from 'forms-utils-lib/embedCode/getEmbedCode';
import getV3EmbedCode from 'forms-utils-lib/embedCode/getV3EmbedCode';
import getV4EmbedCode from 'forms-utils-lib/embedCode/getV4EmbedCode';
import getKnowledgeUrl from 'forms-utils-lib/urls/app/getKnowledgeUrl';
import { EmbedVersion } from 'forms-utils-lib/embedCode/getEmbedCode.types';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMBED_EXTERNALLY_ROUTE = 'forms/how-can-i-share-a-hubspot-form-if-im-using-an-external-site#add-the-form-embed-code';
export default class EmbedCode extends PureComponent {
  constructor(props) {
    super(props);
    this.renderBottomRow = this.renderBottomRow.bind(this);
  }
  maybeRenderIncludeDefaultStylingCheckbox() {
    const {
      customCssEnabled,
      toggleCustomCss,
      isCustomCssDisabled,
      customCssDisabledTooltipTitle,
      customCssDisabledTitle
    } = this.props;
    if (this.props.showDefaultStyling) {
      return null;
    }
    if (isCustomCssDisabled) {
      return /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [customCssDisabledTitle, /*#__PURE__*/_jsx(HelpIcon, {
            marginInlineStart: "100",
            title: customCssDisabledTooltipTitle
          })]
        })
      });
    }
    return /*#__PURE__*/_jsx(Checkbox, {
      checked: !customCssEnabled,
      inline: true,
      onChange: toggleCustomCss,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'editor.options.includeDefaultStyling.header'
      })
    });
  }
  renderBottomRow(componentProps) {
    const {
      onCopy
    } = this.props;
    return /*#__PURE__*/_jsxs(Flex, {
      flexWrap: "wrap",
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsx(CopyButton, Object.assign({}, componentProps, {
        use: "tertiary",
        onClick: onCopy,
        marginBlockStart: "200"
      })), this.maybeRenderIncludeDefaultStylingCheckbox()]
    });
  }
  renderEmbedDescription() {
    return /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "embedCode.message_jsx",
        elements: {
          Link: UILink
        },
        options: {
          href: `${getKnowledgeUrl()}/${EMBED_EXTERNALLY_ROUTE}`,
          external: true
        }
      })
    });
  }
  render() {
    const {
      selectedCampaignId,
      formGuid,
      campaignSelectNode,
      isV3Form,
      isV4Form,
      isSfdcSyncEnabled
    } = this.props;
    let value;
    const embedCodeParams = Object.assign({
      portalId: `${PortalIdParser.get()}`,
      formId: `${formGuid}`,
      region: enviro.getHublet()
    }, enviro.isQa() && {
      env: 'qa'
    }, isSfdcSyncEnabled && selectedCampaignId && {
      sfdcCampaignId: `${selectedCampaignId}`
    });
    if (isV4Form) {
      value = getV4EmbedCode(embedCodeParams);
    } else if (isV3Form) {
      value = getV3EmbedCode(embedCodeParams);
    } else {
      value = getEmbedCode(embedCodeParams, {
        domain: '',
        version: EmbedVersion.V2
      });
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [this.renderEmbedDescription(), campaignSelectNode, /*#__PURE__*/_jsx(CopyTextArea, {
        paddingBlockStart: "400",
        paddingBlockEnd: "400",
        onCopy: this.props.onCopy,
        value: value,
        use: "code",
        buttonRowRenderer: this.renderBottomRow
      })]
    });
  }
}